import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { getCurrentUser } from '../../services/auth';

export default function RouteGuard({ children, role }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ignore = false;
    async function fetchUser() {
      try {
        const u = await getCurrentUser();
        if (!ignore) setUser(u);
      } catch {
        if (!ignore) setUser(null);
      }
      setLoading(false);
    }
    fetchUser();
    return () => { ignore = true; };
  }, []);

  if (loading) return null; // або показати <div>Loading...</div>

  if (!user) return <Navigate to="/login" />;
  if (role && user.role !== role) return <Navigate to="/" />;

  return children;
}
